import * as A from "fp-ts/Array";
import { flow } from "fp-ts/function";
import * as O from "fp-ts/Option";
import { isArray, isNumber, isObject, isString } from "lodash";
import { firstRight } from "../fp-utils";
import { modify } from "./modify";
const isIndexFound = (predicate) => flow(
  (content) => content.nodes,
  A.findIndex(predicate),
  O.fold(
    () => false,
    () => true
  )
);
const isIndexInRange = (index) => (content) => isNumber(index) && index >= 0 && index < (content.nodes?.length ?? 0);
const insertNode = (node, index) => (content) => ({
  ...content,
  nodes: [...content.nodes?.slice(0, index) ?? [], node, ...content.nodes?.slice(index) ?? []]
});
const insertNodeByKey = (node, nodeKey, isAfter = false) => (content) => modify(content).filter(({ id }) => id === nodeKey).set((n) => isAfter ? [n, node] : [node, n]);
function addNode({
  node,
  index,
  before,
  after,
  content
}) {
  return firstRight(content, { ...content, nodes: [...content?.nodes ?? [], node] }, [
    [isIndexInRange(index), insertNode(node, index)],
    [isIndexFound(({ id }) => id === before), insertNodeByKey(node, before, false)],
    [isIndexFound(({ id }) => id === after), insertNodeByKey(node, after, true)]
  ]);
}
const isTextData = (text) => !!text?.text && !!text?.decorations;
const toTextData = (text) => ({ text, decorations: [] });
const isListItemData = (item) => isArray(item.text) && isObject(item.data);
const toListItemData = (data) => (text) => ({ data, text });
const emptyListItemData = { text: [], data: {} };
const toListDataArray = (items, data) => firstRight(
  items,
  [],
  [
    [isString, flow(toTextData, A.of, toListItemData(data), A.of)],
    [isTextData, flow(A.of, toListItemData(data), A.of)],
    [isListItemData, (i) => [i]],
    [
      isArray,
      flow(
        A.map(
          (item) => firstRight(item, emptyListItemData, [
            [isString, flow(toTextData, A.of, toListItemData(data))],
            [isTextData, flow(A.of, toListItemData(data))],
            [isListItemData, (i) => i]
          ])
        )
      )
    ]
  ]
);
const toTextDataArray = (text) => firstRight(
  text,
  [],
  [
    [isString, flow(toTextData, A.of)],
    [isTextData, (t) => [t]],
    [isArray, flow(A.map((t) => firstRight(t, t, [[isString, toTextData]])))]
  ]
);
export {
  addNode,
  toListDataArray,
  toTextDataArray
};
//# sourceMappingURL=builder-utils.js.map
